// Add your custom JS here.

/*

alert( jQuery(window).width() );

console.log(jQuery(window).width());

*/

if (jQuery(window).width() < 767) {
    jQuery('.dropdown-toggle').each(function(){
        jQuery(this).attr('data-bs-toggle','dropdown'); 
    })
}

document.addEventListener('DOMContentLoaded', function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
});

jQuery(document).ready(function() {
    jQuery('#search-region').on('change', function() {
        var selectedValue = jQuery(this).val();

        if (selectedValue === 't-search') {
            jQuery('#search-city-wrapper').show();
            jQuery('#search-city').focus();
        } else {
            jQuery('#search-city-wrapper').hide();
            jQuery('#search-city').val('');
        }
    });

    jQuery('.call_modal').on('click', function(event) {
        event.preventDefault();
        jQuery('#eventModal').modal('show');
        
        var title = jQuery(this).data('title');
        var date = jQuery(this).data('date');
        var permalinkurl = jQuery(this).data('permalinkurl');
        var websiteurl = jQuery(this).data('websiteurl');
        var websitethumbnailurl = jQuery(this).data('websitethumbnailurl');
        var linkedinurl = jQuery(this).data('linkedinurl');
        var xusername = jQuery(this).data('xusername');

        jQuery('#modal-event-title').text(title);
        jQuery('#modal-event-date').text(date);

        jQuery('#modal-event-permalinkurl').attr('href', permalinkurl);

        if (typeof websiteurl !== 'undefined') {
            jQuery('#modal-event-websiteurl').html('Website: <a href="'+websiteurl+'" target="_blank">'+websiteurl+'</a>');
            jQuery('#modal-event-websiteurl-wrapper').show();
        } else {
            jQuery('#modal-event-websiteurl-wrapper').hide();
        }

        if (typeof websitethumbnailurl !== 'undefined') {
            jQuery('#modal-event-websitethumbnailurl').html('<a href="'+websitethumbnailurl+'" target="_blank">'+websitethumbnailurl+'</a>');
            jQuery('#modal-event-websitethumbnailurl').attr('src', websitethumbnailurl);
            jQuery('#modal-event-websitethumbnailurl-wrapper').show();
        } else {
            jQuery('#modal-event-websitethumbnailurl-wrapper').hide();
        }

        if (typeof linkedinurl !== 'undefined') {
            jQuery('#modal-event-linkedinurl').html('LinkedIn: <a href="'+linkedinurl+'" target="_blank">'+linkedinurl+'</a>');
            jQuery('#modal-event-linkedinurl-wrapper').show();
        } else {
            jQuery('#modal-event-linkedinurl').html('');
            jQuery('#modal-event-linkedinurl-wrapper').hide();
        }

        if (typeof xusername !== 'undefined') {
            jQuery('#modal-event-xusername').html('X/Twitter: <a href="https://x.com/'+xusername+'" target="_blank">'+xusername+'</a>');
            jQuery('#modal-event-xusername-wrapper').show();
        } else {
            jQuery('#modal-event-xusername').html('');
            jQuery('#modal-event-xusername-wrapper').hide();
        }
    });

    jQuery('.form-contact').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/wp-json/v1/contact/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {

                jQuery('#contact-form-body').hide();
                jQuery('#contact-form-message').show();

                /*
                jQuery(".form-add-event").trigger("reset");
                jQuery("#add-text").focus();

                jQuery('#add-message').html('<div class="alert alert-success"><h2>Form submitted successfully!</h2><a href="'+data.permalink+'" class="btn btn-success" target="_blank">View event</a></div>').show();

                setTimeout(function() {
                    jQuery('#add-message').hide();
                }, 15000);
                */
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });



    jQuery('.call_event_showhide').on('click', function(event) {
        event.preventDefault();

        var post_id = jQuery(this).data('id');
        var title = jQuery(this).data('title');

        if (confirm("Do you want to report and hide the unverified event '"+title+"'?")){
            jQuery('#event-'+post_id).fadeOut(1000);

            // const formData = new FormData(this);
            var formData = new FormData();
            formData.append('post_id', post_id);

            // Submit form data via fetch
            fetch('/wp-json/v1/showhide-event/', 
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData,
                    headers: {
                        'Accept': 'application/json',
                        // 'X-WP-Nonce': nonce // Send the nonce in the request header
                    }
                })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // OK
                    // alert('Done!');
                } else {
                    alert('Error: ' + data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        };
    });

    
    jQuery('.form-add-event').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/wp-json/v1/save-event/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                jQuery(".form-add-event").trigger("reset");
                jQuery("#add-text").focus();

                jQuery('#add-message').html('<div class="alert alert-success"><h2>Form submitted successfully!</h2><a href="'+data.permalink+'" class="btn btn-success" target="_blank">View event</a></div>').show();

                setTimeout(function() {
                    jQuery('#add-message').hide();
                }, 15000);
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });


    jQuery('.form-add-alert').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/wp-json/v1/save-alert/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                jQuery(".form-add-alert").trigger("reset");
                jQuery("#add-text").focus();

                jQuery('#add-message').html('<div class="alert alert-success"><h2>Form submitted successfully!</h2><a href="'+data.permalink+'" class="btn btn-success" target="_blank">View event</a></div>').show();

                setTimeout(function() {
                    jQuery('#add-message').hide();
                }, 15000);
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });


    // filter events in search form
    document.querySelectorAll('.dropdown-filter').forEach(dropdown => {
        const button = dropdown.querySelector('.dropdown-toggle');
        const items = dropdown.querySelectorAll('.dropdown-item');
        const hiddenInput = dropdown.querySelector('input[type="hidden"]');
    
        items.forEach(item => {
          item.addEventListener('click', function(event) {
            event.preventDefault();
    
            // Remove the active class from all dropdown items in this dropdown
            items.forEach(i => i.classList.remove('active'));
    
            // Add the active class to the clicked item
            this.classList.add('active');
    
            // Get selected value and text (icon + text)
            const selectedValue = this.getAttribute('data-value');
            const selectedText = this.innerHTML;

            if (selectedValue === 'search-form') {
                // Redirect to the desired URL
                window.location.href = '/events/?show=search-form';
            }

            // Update the button to show the selected item (with icon)
            button.innerHTML = selectedText;
    
            // Update the hidden input value
            hiddenInput.value = selectedValue;
          });
        });
    });



    // Tooltip initialization
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Event bar click handler
    document.querySelectorAll('.event-bar').forEach(function (eventBar) {
        eventBar.addEventListener('click', function () {
            var eventTitle = this.innerText;
            var eventContent = 'Details about ' + eventTitle;
            showModal(eventTitle, eventContent);
        });
    });

    function showModal(title, content) {
        var modalHTML = `
        <div class="modal fade" id="eventModal" tabindex="-1" aria-labelledby="eventModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="eventModalLabel">${title}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        ${content}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>`;
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        var modal = new bootstrap.Modal(document.getElementById('eventModal'));
        modal.show();
    }
    


});


